var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-details"},[(_vm.user.name)?_c('h3',{staticClass:"title-20px mb-6"},[_vm._v(_vm._s(_vm.user.name)+" -"),(_vm.user.email)?_c('span',{staticClass:"text-16px dark pl-1"},[_vm._v(_vm._s(_vm.user.email))]):_vm._e()]):_vm._e(),_c('e-tabs',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }